/**
 * Background catalog API — owned S3 + curated Unsplash.
 * GET /api/background-presets?catalog=image|ai_preset&source=owned|unsplash|all
 */
import apiClient from "../client";

/**
 * @param {{
 *   catalog?: 'image' | 'ai_preset',
 *   main_slug?: string,
 *   sub_category_id?: number,
 *   source?: 'owned' | 'unsplash' | 'all',
 * }} [opts]
 */
export const getBackgroundPresets = async (opts = {}) => {
  const params = { catalog: opts.catalog || "image" };
  if (opts.main_slug) params.main_slug = opts.main_slug;
  if (opts.sub_category_id != null) params.sub_category_id = opts.sub_category_id;
  if (opts.source) params.source = opts.source;
  const response = await apiClient.get("/api/background-presets", { params });
  return response.data;
};
